/* eslint-disable @typescript-eslint/no-explicit-any */
import { TextField, styled } from '@mui/material';
import React, { useState } from 'react';
import './SearchComponent.css';
import { useTranslation } from 'react-i18next';
import Compdirection from '../themes/CompDirection';
import { themes } from '../themes/themes';

const CustomTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: themes.primary,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: themes.primary,
  },
});

const SearchComponent = (props: any) => {
  const { t } = useTranslation();
  const trans: any = t;
  const [val, setVal] = useState('');

  const handleSeach = (e: any) => {
    setVal(e.target.value);
    props.onChange(e.target.value);
  };

  return (
    <Compdirection>
      <CustomTextField
        onChange={handleSeach}
        value={val}
        placeholder={`${trans('Search here')}...`}
        inputProps={{
          'aria-label': 'search',
          style: {
            padding: props?.padding ?? '15px',
          },
        }}
        style={{
          width: props.width,
          alignContent: 'center',
        }}
        classes={props?.classes?.container}
        InputProps={{
          classes: props?.classes?.input,
          startAdornment: (
            <i
              className="las la-search"
              style={{
                color: '#8F95B2',
                marginTop: '3px',
              }}
            />
          ),
        }}
      />
    </Compdirection>
  );
};
export default SearchComponent;
